import { formatDateTime } from 'utils/dates/date.utils';
import { getAlertUntilDate } from '../../AlertList/features/AlertCard/utils/alertCard.utils';

/**
 * Renders the fallback summary for a FEMA alert without a full CAP version.
 *
 * @param {{ alert: object }} props - FEMA alert card data.
 * @returns {JSX.Element} The FEMA summary block.
 */
const FemaMessageSummary = ({ alert }) => (
  <div>
    <div className="my-2 fs-5 fw-bold">
      {alert.provider?.toLowerCase().includes('fusion') && (
        <div>
          <div className="fs-5">{alert.description}</div>
          <div className="fs-5">Until: {formatDateTime(alert.valid_until_time_utc)}</div>
        </div>
      )}
      {alert.smpp_message.split(';').map((alertMessageLine, index) => (
        <div key={index} className="fs-6">
          {alertMessageLine.includes('till:')
            ? `Until: ${formatDateTime(getAlertUntilDate(alertMessageLine))}`
            : alertMessageLine}
        </div>
      ))}
    </div>
    <ul className="mb-3 fs-6">
      {alert.message.split('*').map(
        (alertMessageLine, index) =>
          alertMessageLine && (
            <li key={index} className="ms-3 fs-6">
              {alertMessageLine}
            </li>
          ),
      )}
    </ul>
  </div>
);

export default FemaMessageSummary;
